import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Industries from "./pages/Industries";
import Portfolio from "./pages/Portfolio";
import CaseStudy from "./pages/CaseStudy";
import Metamorphosis from "./pages/Metamorphosis";
import Innovation from "./pages/Innovation";
import Insights from "./pages/Insights";
import InsightDetail from "./pages/InsightDetail";
import Contact from "./pages/Contact";
import LegalPage from "./pages/LegalPage";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminResetPassword from "./pages/admin/AdminResetPassword";
import ErrorBoundary from "./components/ErrorBoundary";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: { background: "#141414", border: "1px solid rgba(255,255,255,0.12)", color: "#fff", borderRadius: 0 },
          }}
        />
        <ErrorBoundary>
        <Routes>
          <Route path="/" element={withLayout(<Home />)} />
          <Route path="/about" element={withLayout(<About />)} />
          <Route path="/services" element={withLayout(<Services />)} />
          <Route path="/industries" element={withLayout(<Industries />)} />
          <Route path="/portfolio" element={withLayout(<Portfolio />)} />
          <Route path="/portfolio/:slug" element={withLayout(<CaseStudy />)} />
          <Route path="/metamorphosis" element={withLayout(<Metamorphosis />)} />
          <Route path="/innovation" element={withLayout(<Innovation />)} />
          <Route path="/insights" element={withLayout(<Insights />)} />
          <Route path="/insights/:slug" element={withLayout(<InsightDetail />)} />
          <Route path="/contact" element={withLayout(<Contact />)} />
          <Route path="/privacy" element={withLayout(<LegalPage type="privacy" />)} />
          <Route path="/terms" element={withLayout(<LegalPage type="terms" />)} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={withLayout(<NotFound />)} />
        </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
